import { Authentication } from '@leedpulse-monorepo/classes';
import HttpClient from '../../../core/HttpClient';

export type TStripeProductStatusFilter = 'all' | 'active' | 'archived';
export type TStripeProductVisibilityFilter = 'all' | 'public' | 'private';

interface ILeedflowStripeCatalogPlan {
  id: string;
  name: string;
  has_valid_stripe_price: boolean;
  active: boolean;
  archived: boolean;
  warning?: 'inactive_price';
}

interface ILeedflowStripeCatalogPrice {
  id: string;
  active: boolean;
  unit_amount: number;
  currency: string;
  recurring: { interval: string } | null;
  formatted_amount: string;
  dashboard_url: string;
  plans: ILeedflowStripeCatalogPlan[];
}

interface ILeedflowStripeCatalogProduct {
  id: string;
  name: string;
  description: string | null;
  active: boolean;
  plans_count: number;
  dashboard_url: string;
  prices: ILeedflowStripeCatalogPrice[];
}

export interface ILeedflowStripeCatalogResponse {
  products: ILeedflowStripeCatalogProduct[];
  orphan_plans: Array<
    | { id: string; name: string; issue: 'missing_price' }
    | { id: string; name: string; issue: 'unknown_price'; stripe_price_id: string }
  >;
  stripe_dashboard_base: string;
  product_status: string;
}

interface ListLeedflowProductsWithPlansOptions {
  product_status?: TStripeProductStatusFilter;
  visibility?: TStripeProductVisibilityFilter;
}

/**
 * Fetch Leedflow Stripe products + prices + linked plans.
 * Mirrors the backoffice usage (same route, same { success, data } shape).
 */
export default async function listLeedflowProductsWithPlans(
  companyApiKey: string,
  auth: Authentication,
  opts: ListLeedflowProductsWithPlansOptions = { product_status: 'active', visibility: 'public' }
): Promise<ILeedflowStripeCatalogResponse> {
  const params = new URLSearchParams();
  if (opts.product_status) params.set('product_status', opts.product_status);
  if (opts.visibility) params.set('visibility', opts.visibility);

  const json = await HttpClient.get(
    `/leedflow/stripe/backoffice/products-with-plans?${params.toString()}`,
    auth.token,
    {
      'x-api-key': companyApiKey,
    }
  );

  if (json?.success && json.data) {
    return json.data as ILeedflowStripeCatalogResponse;
  }

  throw new Error('Erreur lors de la récupération du catalogue Stripe');
}

